<template>
  <ul>
    <li v-if="parent">
      <template v-if="$root.enable_piwik_reload">
        <a
          class="parent-link"
          v-if="parent.object === 'custom'"
          :href="parent.url"
          @click="$emit('closePanel')"
        >
          <span>{{ parent.title }}</span>
        </a>
        <a
          v-else
          :href="getRouteLink(parent.slug, parent.object, parent.base_slug)"
          @click="$emit('closePanel')"
          class="parent-link"
        >
          <span>{{ parent.title }}</span>
        </a>
      </template>
      <template v-else>
        <a
          class="parent-link"
          v-if="parent.object === 'custom'"
          :href="parent.url"
          @click="$emit('closePanel')"
        >
          <span>{{ parent.title }}</span>
        </a>
        <router-link
          v-else
          :to="getRouteLink(parent.slug, parent.object, parent.base_slug)"
          @click.native="$emit('closePanel')"
          class="parent-link"
        >
          <span>{{ parent.title }}</span>
        </router-link>
      </template>
    </li>
    <li v-for="menu in menus" :key="menu.ID">
      <template v-if="menu.children && menu.children.length > 0">
        <a class="page-links">
          <span>{{ menu.title }}</span>
        </a>
        <MobileChildMenu
          :parent="menu"
          :menus="menu.children"
          @closePanel="$emit('closePanel')"
        />
      </template>
      <template v-else>
        <template v-if="menu.object === 'custom'">
          <a
            class="page-links"
            v-if="menu.url && menu.url != ''"
            :href="menu.url"
            @click="$emit('closePanel')"
          >
            <span>{{ menu.title }}</span>
          </a>
          <template v-else>
            <span class="mb-span">{{ menu.title }}</span>
          </template>
        </template>
        <template v-else>
          <template v-if="$root.enable_piwik_reload">
            <a
              :href="getRouteLink(menu.slug, menu.object, menu.base_slug)"
              @click="$emit('closePanel')"
              class="page-links"
            >
              <span>{{ menu.title }}</span>
            </a>
          </template>
          <template v-else>
            <router-link
              :to="getRouteLink(menu.slug, menu.object, menu.base_slug)"
              @click.native="$emit('closePanel')"
              class="page-links"
            >
              <span>{{ menu.title }}</span>
            </router-link>
          </template>
        </template>
      </template>
    </li>
  </ul>
</template>

<script>
import MobileChildMenu from "./MobileChildMenu";

export default {
  name: "MobileChildMenu",
  props: ["menus", "parent"],
  components: {
    MobileChildMenu,
  },
};
</script>

<style lang="less" scoped>
.page-links {
  color: #191923 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  display: block;
  padding: 15px 20px 15px 11px;
  margin: 0;
  flex-grow: 1;
  flex-basis: 10%;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  font-family: var(--default-regular);
}
.parent-link {
  color: #191923 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  display: block;
  padding: 15px 20px 15px 11px;
  margin: 0;
  flex-grow: 1;
  flex-basis: 10%;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  font-family: var(--default-regular);
  span {
    color: #191923 !important;
  }
}

.mb-span {
  padding-left: 23px;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/HeaderMobMenu/MobileChildMenu.vue